import { JsonApiClient } from "@/modules/api/utils/createJsonApiClient/createJsonApiClient";

import { completeTutorialStepPath } from "../resources/tutorial/tutorialResourceConsts";
import { tutorialStepResourceType } from "../resources/tutorialStep/tutorialStepResourceConsts";

type CompleteStepMutationPayload = {
  companyId: string;
  tutorialStepId: string;
  tutorialId: string;
  tutorialVersion: string;
};

export function completeStepMutation(jsonApi: JsonApiClient) {
  return ({
    companyId,
    tutorialStepId,
    tutorialId,
    tutorialVersion,
  }: CompleteStepMutationPayload) => {
    return jsonApi.createOne({
      path: completeTutorialStepPath(companyId, tutorialId),
      id: tutorialStepId,
      type: tutorialStepResourceType,
      externalMeta: {
        tutorialVersion,
      },
    });
  };
}
